import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import style from './EcsInactiveModal.module.scss';
import useClickAwayListener from '../../../hooks/useClickAwayLitsner';
import { getSourceValue } from '../../../lib/common';
import { useLocalStorage } from '../../../hooks';
import { handleImpressionsTrack } from '../../../api';
import { useAuth } from '../../../contexts/auth';

const EcsInactiveModal = ({ ecsInactivePopupData, setEcsInactivePopupData }) => {
  const navigate = useNavigate();
  const source = getSourceValue();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [authState] = useAuth();

  const handleEcsInactivePopup = () => {
    const ecsInactiveData = JSON.parse(localStorage.getItem('ecsInactiveData')) || [];
    const storedDataArr = ecsInactiveData?.filter((each) => each?.docid === selectedBusiness?.docid);

    if (storedDataArr?.length === 0) {
      const updatedData = [
        {
          docid: selectedBusiness?.docid,
          opened: true,
        },
        ...ecsInactiveData,
      ];
      localStorage.setItem('ecsInactiveData', JSON.stringify(updatedData));
    }
    setEcsInactivePopupData({});
  };

  const ecsModalRef = useRef(null);
  useClickAwayListener(ecsModalRef, () => {
    handleEcsInactivePopup();
  });

  const handleEcsFaqRedirection = async () => {
    localStorage.setItem('searchQid', ecsInactivePopupData?.showFaqId || '');

    const liVal = 'click';
    const liTrd = 'ecsprompt';
    const faqTypeVal = '';
    const othersData = [];
    const llTrd = 'ecsprompt';
    await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);

    handleEcsInactivePopup();
    navigate(`/csportal/ecs?source=${source}`);
  };

  return (
    <section className={`cs_modal ${style.Modal}`}>
      <div ref={ecsModalRef} className={`cs_modal_content cs_modal_animation cs_modal_up ${style.Modal__Content} `}>
        <div
          className="csgrievance_headtxt popup-heading-div font15 fw600 color111 pr-10 pt-10"
          style={{ justifyContent: 'flex-end' }}
        >
          <div
            className="modal_close csicon"
            onClick={() => handleEcsInactivePopup()}
            aria-label="Close Modal"
            type="button"
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
          />
        </div>
        <div className={`${style.Modal__Body} cs_modal_body p-20`}>
          <div className={`${style.ImageBox}`}>
            <img
              alt="EcsInactive"
              className=""
              src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/EcsInactive.svg"
              width={125}
              height={125}
            />
          </div>
          <div className="font18 fw600 color111 mt-15">{`Your ECS is ${ecsInactivePopupData?.ecsStatus || 'Inactive'}!`}</div>
          <div className="font14 fw400 color111 mt-4">To avoid disruption in services</div>
          <button
            onClick={handleEcsFaqRedirection}
            type="button"
            className={`${style.Button} bluefill_animate font14 fw600 colorFFF mt-20`}
          >
            Activate Now
          </button>
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={() => handleEcsInactivePopup()}
            className={`${style.AnchorGroup} mt-15`}
          >
            <span className="font13 fw400 color777 pointer">Maybe later</span>
          </div>
        </div>
      </div>
    </section>
  );
};
export default EcsInactiveModal;
EcsInactiveModal.propTypes = {
  ecsInactivePopupData: PropTypes.func,
  setEcsInactivePopupData: PropTypes.func,
};
